import { useEffect } from "react";
import { useForm } from "@/base/utils/index";
import { useLoader } from "@/app/hook/use-loader";
import { useLocalization } from "@/app/hook/use-localization";
import { BillingInvoiceItemType } from "@/schemas/index";
import { useLoaderData } from "react-router";

export function usePageInvoiceViewHook() {
  const [form] = useForm();
  const localization = useLocalization();
  const { setLoader } = useLoader();
  const invoice = useLoaderData<BillingInvoiceItemType>();

  const { currentLang } = localization;

  useEffect(() => {
    setLoader(false);
  }, []);

  return { form, currentLang, invoice };
}
